import { useEffect, useState } from 'react'
import { ReferencedValueSnapshot } from '../../../../domain/value-object/ProjectPlanSnapshot'
import { useProjectPlanSnapshotRepository } from '../../../../services/adaptors/projectPlanSnapshotRepositoryAdaptor'

export type UseSnapshotTeamsReturnValue = ReturnType<typeof useSnapshotTeams>

export const useSnapshotTeams = (snapshotUuid: string) => {
  const { fetchReferencedValues } = useProjectPlanSnapshotRepository()
  const [teamMap, setTeamMap] = useState<Map<string, ReferencedValueSnapshot>>(
    new Map()
  )

  useEffect(() => {
    let cancelled = false
    fetchReferencedValues(snapshotUuid, 'TEAM_ENTITY')
      .then(list => {
        if (cancelled) return
        setTeamMap(new Map(list.map(v => [v.value, v])))
      })
      .catch(error => {
        console.error('Failed to fetch snapshot teams:', error)
      })
    return () => {
      cancelled = true
    }
  }, [snapshotUuid, fetchReferencedValues])

  return teamMap
}
